import { render, staticRenderFns } from "./hr_bussiness_config.vue?vue&type=template&id=b4aab97c&scoped=true"
import script from "./hr_bussiness_config.vue?vue&type=script&lang=js"
export * from "./hr_bussiness_config.vue?vue&type=script&lang=js"
import style0 from "./hr_bussiness_config.vue?vue&type=style&index=0&id=b4aab97c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aab97c",
  null
  
)

export default component.exports